import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import PolygonMap from './polygon_map';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { isEmpty } from 'lodash';

const LocationMap = ({ location, onPolygonChange, googleMapsApiKey, clearBtnRef }) => {
  const polygonGeojson = location ? location.polygonGeojson : {};

  const isClearBtnVisible = location.polygonSearch && clearBtnRef.current && !isEmpty(polygonGeojson);
  const clearBtn = <button className="pl-0 ps-0 btn btn-link" name={'clear-btn'} onClick={() => onPolygonChange({})}>
    <FontAwesomeIcon className="mr-2 me-2" icon={faTimes} size="lg" />
    Clear Drawing
  </button>;

  return (
    <React.Fragment>
      <div>
        <PolygonMap
          fitBoundsDelay={300}
          geoJSON={polygonGeojson}
          googleMapsApiKey={googleMapsApiKey}
          onPolygonComplete={onPolygonChange}
        />
      </div>

      {isClearBtnVisible && ReactDOM.createPortal(clearBtn, clearBtnRef.current)}
    </React.Fragment>
  );
};

LocationMap.propTypes = {
  clearBtnRef: PropTypes.object.isRequired,
  googleMapsApiKey: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  onPolygonChange: PropTypes.func.isRequired
};

export default LocationMap;
